var _line, _polyline, _g, _g2, _g3, _circle, _path, _path2, _path3, _path4, _path5, _line2, _g4, _g5, _polyline2, _polyline3, _g6, _g7, _circle2, _g8, _g9, _g10, _line3, _polyline4, _line4, _g11, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _g12, _g13, _g14, _line5, _line6, _line7, _line8, _line9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoallexperiments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496.5 284",
    enableBackground: "new 0 0 496.5 284",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1069_",
    fill: "#666666",
    stroke: "#9A9A9A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 8.9,
    y1: 256,
    x2: 488.9,
    y2: 256
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_1047_",
    fill: "#DEDEDF",
    points: "115.2,185.1 90.2,163.6 121.7,206.5 155.1,172.5 152.4,172.9 126.7,194.5  90.2,163.6 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_721_"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1050_",
    cx: 131.5,
    cy: 121.7,
    r: 36.3
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_1050_",
    overflow: "visible",
    fill: "#DEDEDF"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_107_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_1050_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1036_",
    clipPath: "url(#XMLID_107_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1143_",
    fill: "#9A9A9A",
    d: "M153.1,159.5h-42.5l6-24c0.6-2.5,2.9-4.3,5.5-4.3h19.5c2.6,0,4.9,1.8,5.5,4.3 L153.1,159.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_430_",
    fill: "#9A9A9A",
    d: "M131.5,124.3L131.5,124.3c-5.9,0-10.6-4.8-10.6-10.6V108c0-5.9,4.8-10.6,10.6-10.6h0 c5.9,0,10.6,4.8,10.6,10.6v5.7C142.2,119.5,137.4,124.3,131.5,124.3z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_1050_",
    overflow: "visible",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_527_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_78_",
    fill: "#FFFFFF",
    d: "M383.1,257.5c-6.5,0-11.8-5.3-11.8-11.8s5.3-11.8,11.8-11.8s11.8,5.3,11.8,11.8 S389.6,257.5,383.1,257.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_44_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_75_",
    fill: "#666666",
    d: "M383.1,239c3.7,0,6.8,3,6.8,6.8s-3,6.8-6.8,6.8s-6.8-3-6.8-6.8S379.4,239,383.1,239  M383.1,229c-9.3,0-16.8,7.5-16.8,16.8c0,9.3,7.5,16.8,16.8,16.8s16.8-7.5,16.8-16.8C399.9,236.5,392.4,229,383.1,229L383.1,229z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_598_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_519_",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    points: "430.9,245.4  351.5,245.4 351.5,183.6 409.5,183.6  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_518_",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M380.5,113.1L380.5,113.1 c-16,0-29,13-29,29v41.5h58v-41.5C409.5,126.1,396.5,113.1,380.5,113.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_649_",
    fill: "#DEDEDF",
    d: "M380.5,113.1L380.5,113.1c-16,0-29,13-29,29v102.5h16v-96.2 C367.5,122.7,380.5,113.1,380.5,113.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_521_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_520_",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 362.9,
    y1: 200,
    x2: 414.9,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_522_",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 362.9,
    y1: 214,
    x2: 419.9,
    y2: 214
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_523_",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 362.9,
    y1: 229,
    x2: 424.9,
    y2: 229
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_684_",
    x: 397.7,
    y: 189.2,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -18.368 339.1645)",
    fill: "#666666",
    width: 5.1,
    height: 5.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_90_",
    x: 397.7,
    y: 204.2,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -28.9746 343.5579)",
    fill: "#666666",
    width: 5.1,
    height: 5.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_112_",
    x: 397.7,
    y: 219.2,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -39.5812 347.9513)",
    fill: "#666666",
    width: 5.1,
    height: 5.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_158_",
    x: 397.7,
    y: 234.2,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -50.1878 352.3447)",
    fill: "#666666",
    width: 5.1,
    height: 5.1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1049_",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    points: "430.9,245.4 351.5,245.4  351.5,183.6 409.5,183.6  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1051_",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M380.5,113.1L380.5,113.1 c-16,0-29,13-29,29v41.5h58v-41.5C409.5,126.1,396.5,113.1,380.5,113.1z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_166_",
    fill: "#DEDEDF",
    stroke: "#666666",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 397.4,
    cy: 140.9,
    r: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_167_",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M403.5,143 c-0.6-2.6-3-4.6-5.9-4.6s-5.2,2-5.9,4.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_495_",
    fill: "#9A9A9A",
    d: "M405.2,167c0,4-3.6,8-8,8c-4.4,0-8-4-8-8H405.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_499_",
    fill: "#DEDEDF",
    stroke: "#666666",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M385.2,113.1 c12.7-13.9,5.3-34.7,5.3-34.7L338.2,112l15.3,14.8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1102_",
    fill: "#FFFFFF",
    d: "M389.6,105.4c-3.9-1.3-6.2-4.8-6.2-9c0-5.2,3.5-9.5,9.5-9.5 C393.2,89,393.2,97.9,389.6,105.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1103_",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M385.2,113.1 c12.7-13.9,5.3-34.7,5.3-34.7L338.2,112l15.3,14.8"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_695_",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 6,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    x1: 350.5,
    y1: 130.2,
    x2: 393.2,
    y2: 111.6
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1046_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1037_",
    fill: "#DEDEDF",
    d: "M195.2,106.5c-10.7-2.8-17-13.7-14.2-24.4v0c2.8-10.7,13.7-17,24.4-14.2l0,0 c-14.1,4.9-19.7,25.8-10.4,37.9L195.2,106.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1045_",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: " M195.2,106.5c-10.7-2.8-17-13.7-14.2-24.4v0c2.8-10.7,13.7-17,24.4-14.2l98.9,26c10.7,2.8,17,13.7,14.2,24.4v0 c-2.8,10.7-13.7,17-24.4,14.2l-26.6-7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_22_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_23_",
    fill: "#9A9A9A",
    d: "M212.8,86l-2.2,8.2l-2-0.5l-1.8-5.8l0,0l-1.3,4.9l-1.9-0.5l2.2-8.2l1.9,0.5l1.9,5.9 l1.3-5.1L212.8,86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    fill: "#9A9A9A",
    d: "M216.1,86.9l5.4,1.4L221,90l-3.5-0.9l-0.4,1.6l2.7,0.7l-0.4,1.7l-2.7-0.7l-0.4,1.5l3.7,1 l-0.5,1.7l-5.6-1.5L216.1,86.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    fill: "#9A9A9A",
    d: "M235.6,92l-4.7,7.6l-1.8-0.5l0-5.8l0,0l-2.9,5l-1.8-0.5l-0.4-8.9l2.1,0.5l0.1,5.4l0,0 l2.6-4.7l2,0.5l-0.1,5.4l0,0l2.7-4.7L235.6,92z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_29_",
    fill: "#9A9A9A",
    d: "M247.8,101.5c-0.3,1.3-1.5,2.1-3.2,1.6l-3.6-0.9l2.2-8.2l3.1,0.8c1.8,0.5,2.5,1.5,2.2,2.7 c-0.2,0.7-0.7,1.4-1.7,1.5l0,0C247.7,99.6,248,100.5,247.8,101.5z M245.8,100.7c0.1-0.5-0.2-1-1-1.2l-1.1-0.3l-0.5,1.7l1.1,0.3 C245.1,101.5,245.7,101.3,245.8,100.7z M244.1,97.7L245,98c0.6,0.2,1.1,0,1.3-0.5c0.1-0.5-0.1-0.9-0.9-1.1l-0.8-0.2L244.1,97.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_33_",
    fill: "#9A9A9A",
    d: "M250.9,101.1l1.3-4.8l2,0.5l-1.2,4.7c-0.3,1,0,2,1,2.2c0.8,0.2,1.7-0.3,2-1.5l1.2-4.7 l1.9,0.5l-1.3,4.8c-0.6,2.1-2.2,3.2-4.4,2.7C251.3,105,250.3,103.4,250.9,101.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_40_",
    fill: "#9A9A9A",
    d: "M263.4,101.1l-2.2-0.6l0.5-1.7l6.3,1.6l-0.5,1.7l-2.2-0.6l-1.7,6.5l-1.9-0.5L263.4,101.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_42_",
    fill: "#9A9A9A",
    d: "M272,103.4l-2.2-0.6l0.5-1.7l6.3,1.6l-0.5,1.7l-2.2-0.6l-1.7,6.5l-1.9-0.5L272,103.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_93_",
    fill: "#9A9A9A",
    d: "M277.6,107.4c0.7-2.5,2.8-3.8,5.4-3.1c2.5,0.6,3.8,2.8,3.1,5.3c-0.7,2.5-2.9,3.8-5.3,3.1 C278.2,112.1,276.9,109.9,277.6,107.4z M284,109.1c0.4-1.4-0.3-2.7-1.6-3c-1.3-0.3-2.5,0.5-2.9,1.8c-0.4,1.3,0.3,2.7,1.6,3 C282.5,111.3,283.7,110.4,284,109.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_96_",
    fill: "#9A9A9A",
    d: "M297.2,108.1l-2.2,8.2l-2-0.5l-1.8-5.8l0,0l-1.3,4.9l-1.9-0.5l2.2-8.2l1.9,0.5l1.9,5.9 l1.3-5.1L297.2,108.1z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_639_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1054_",
    fill: "#9A9A9A",
    stroke: "#666666",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M256.2,211.8h72.4v-65.4 c0-4.4-3.6-8-8-8h-64.4V211.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_636_",
    x: 256.2,
    y: 152,
    fill: "#666666",
    width: 72.4,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_638_",
    x: 256.2,
    y: 174,
    fill: "#DEDEDF",
    width: 48.2,
    height: 17.7
  }))), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_607_",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    points: " 149.6,162.8 90.2,162.8 90.2,203.3 "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_608_",
    fill: "#F3F3F3",
    stroke: "#666666",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    points: "256.2,212.2  256.2,113.5 149.6,113.5 149.6,212.2 "
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_635_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_21_",
    x: 160.2,
    y: 123.7,
    fill: "#DEDEDF",
    width: 85.4,
    height: 78.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    fill: "#666666",
    d: "M244.6,124.7v76.1h-83.4v-76.1H244.6 M246.6,122.7h-2h-83.4h-2v2v76.1v2h2h83.4h2v-2v-76.1 V122.7L246.6,122.7z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_610_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_433_",
    fill: "#DEDEDF",
    stroke: "#666666",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M335.2,245.4H81.6 c-2.2,0-4-1.8-4-4V212h261.6v29.3C339.2,243.6,337.4,245.4,335.2,245.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_524_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_84_",
    fill: "#FFFFFF",
    d: "M116.1,257.5c-6.5,0-11.8-5.3-11.8-11.8s5.3-11.8,11.8-11.8s11.8,5.3,11.8,11.8 S122.6,257.5,116.1,257.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_80_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_81_",
    fill: "#666666",
    d: "M116.1,239c3.7,0,6.8,3,6.8,6.8s-3,6.8-6.8,6.8s-6.8-3-6.8-6.8S112.4,239,116.1,239  M116.1,229c-9.3,0-16.8,7.5-16.8,16.8c0,9.3,7.5,16.8,16.8,16.8c9.3,0,16.8-7.5,16.8-16.8C132.9,236.5,125.4,229,116.1,229 L116.1,229z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_526_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_91_",
    fill: "#FFFFFF",
    d: "M300.1,257.5c-6.5,0-11.8-5.3-11.8-11.8s5.3-11.8,11.8-11.8s11.8,5.3,11.8,11.8 S306.6,257.5,300.1,257.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_86_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_87_",
    fill: "#666666",
    d: "M300.1,239c3.7,0,6.8,3,6.8,6.8s-3,6.8-6.8,6.8s-6.8-3-6.8-6.8S296.4,239,300.1,239  M300.1,229c-9.3,0-16.8,7.5-16.8,16.8c0,9.3,7.5,16.8,16.8,16.8s16.8-7.5,16.8-16.8C316.9,236.5,309.4,229,300.1,229L300.1,229z "
  }))))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_428_",
    fill: "#FFFFFF",
    cx: 226.7,
    cy: 143.2,
    r: 9.2
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_429_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_497_",
    fill: "#FFFFFF",
    points: "244.6,178 234.2,167.5 215.5,186.1 184.5,155.2 161.2,178.5 161.2,200.9  244.6,200.9  "
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_98_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_99_",
    fill: "#9A9A9A",
    d: "M281.3,185.2h-1.4v2.3h-1.5v-2.3h-3.6v-1.1l3.8-5.1h1.3v4.9h1.4V185.2z M278.4,181.3 l-2.1,2.7h2.1V181.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_102_",
    fill: "#9A9A9A",
    d: "M284.7,186.2h1.8V181l-1.6,1.2l-0.7-1l2.7-2.1h1.1v7.1h1.8v1.3h-5.1V186.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_104_",
    fill: "#9A9A9A",
    d: "M295.6,186.4c0.3,0,0.5,0,0.7-0.1c0.2-0.1,0.4-0.2,0.6-0.3c0.2-0.1,0.3-0.3,0.4-0.4 c0.1-0.2,0.1-0.3,0.1-0.5c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.2-0.3-0.4-0.4s-0.4-0.2-0.6-0.2c-0.2,0-0.5-0.1-0.8-0.1h-0.7v-0.9l2-2.5 h-3v-1.3h4.9v1.1l-2.1,2.4h0.3c0.3,0,0.6,0,0.8,0.1c0.3,0.1,0.5,0.2,0.7,0.4c0.2,0.2,0.4,0.4,0.5,0.7s0.2,0.6,0.2,1 c0,0.5-0.1,0.9-0.3,1.2c-0.2,0.3-0.4,0.6-0.7,0.9c-0.3,0.2-0.7,0.4-1.1,0.5c-0.4,0.1-0.8,0.2-1.2,0.2c-0.4,0-0.7,0-1.1-0.1 c-0.4-0.1-0.7-0.2-1-0.3l0.4-1.3c0.1,0,0.2,0.1,0.3,0.1s0.3,0.1,0.4,0.1s0.3,0.1,0.5,0.1C295.2,186.4,295.4,186.4,295.6,186.4z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_644_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_643_",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 6,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    d: " M153.4,43.7l2.4-8.7c1.5-5.5,7.2-8.7,12.7-7.2l0,0c5.5,1.5,8.7,7.2,7.2,12.7l-2.4,8.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1019_",
    fill: "#DEDEDF",
    d: "M140.7,81.2l-4.3-1.2c-2.1-0.6-3.4-2.8-2.8-4.9l7.8-27.9c0.6-2.1,2.8-3.4,4.9-2.8l4.3,1.2 L140.7,81.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_641_",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M169,89.1L136.4,80 c-2.1-0.6-3.4-2.8-2.8-4.9l7.8-27.9c0.6-2.1,2.8-3.4,4.9-2.8l32.6,9.1c2.1,0.6,3.4,2.8,2.8,4.9L174,86.3 C173.4,88.5,171.2,89.7,169,89.1z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_642_",
    fill: "#F3F3F3",
    stroke: "#666666",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 140.7,
    y1: 50.4,
    x2: 181.2,
    y2: 61.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_646_",
    fill: "#F3F3F3",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 162.8,
    y1: 64.9,
    x2: 178.2,
    y2: 69.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_647_",
    fill: "#F3F3F3",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 161.2,
    y1: 70.7,
    x2: 176.5,
    y2: 75
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_648_",
    fill: "#F3F3F3",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 159.6,
    y1: 76.5,
    x2: 174.9,
    y2: 80.8
  }))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1065_",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 6,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    x1: 341.8,
    y1: 229,
    x2: 348.3,
    y2: 229
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_637_",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    points: " 149.6,175.1 127,194.4 90.2,162.8 "
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1101_",
    fill: "none",
    stroke: "#DEDEDF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 286.9,
    y1: 198,
    x2: 303.9,
    y2: 198
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1024_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_14_",
    x: 29.9,
    y: 276,
    fill: "#DEDEDF",
    width: 15,
    height: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    fill: "#DEDEDF",
    d: "M428.9,284h-32v-8h32V284z M364.9,284h-32v-8h32V284z M300.9,284h-32v-8h32V284z M236.9,284 h-32v-8h32V284z M172.9,284h-32v-8h32V284z M108.9,284h-32v-8h32V284z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5_",
    x: 456.9,
    y: 276,
    fill: "#DEDEDF",
    width: 15,
    height: 8
  })))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1145_",
    fill: "#DEDEDF",
    cx: 64.7,
    cy: 61.5,
    r: 3.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1020_",
    fill: "#DEDEDF",
    cx: 433.7,
    cy: 75.5,
    r: 3.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1053_",
    fill: "#DEDEDF",
    cx: 299.7,
    cy: 3.5,
    r: 3.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1058_",
    fill: "#DEDEDF",
    cx: 240.7,
    cy: 51.5,
    r: 3.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1144_",
    fill: "#DEDEDF",
    cx: 9.2,
    cy: 143.1,
    r: 1.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_973_",
    fill: "#DEDEDF",
    cx: 63.2,
    cy: 113.1,
    r: 1.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_974_",
    fill: "#DEDEDF",
    cx: 430.2,
    cy: 115.1,
    r: 1.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_938_",
    fill: "#DEDEDF",
    cx: 256.2,
    cy: 26.1,
    r: 1.5
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1021_",
    fill: "#DEDEDF",
    cx: 454.2,
    cy: 129.1,
    r: 1.5
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1059_",
    fill: "#DEDEDF",
    cx: 270.2,
    cy: 36.1,
    r: 1.5
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1060_",
    fill: "#DEDEDF",
    cx: 315.2,
    cy: 62.1,
    r: 1.5
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_966_",
    fill: "#DEDEDF",
    cx: 41.2,
    cy: 68.1,
    r: 1.5
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1140_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1142_",
    fill: "none",
    stroke: "#DEDEDF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 34.9,
    y1: 102,
    x2: 34.9,
    y2: 112
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1141_",
    fill: "none",
    stroke: "#DEDEDF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 39.9,
    y1: 107,
    x2: 29.9,
    y2: 107
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_970_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_972_",
    fill: "none",
    stroke: "#DEDEDF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 337.9,
    y1: 41,
    x2: 337.9,
    y2: 51
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_971_",
    fill: "none",
    stroke: "#DEDEDF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 342.9,
    y1: 46,
    x2: 332.9,
    y2: 46
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1055_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1057_",
    fill: "none",
    stroke: "#DEDEDF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 453.9,
    y1: 203,
    x2: 453.9,
    y2: 213
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1056_",
    fill: "none",
    stroke: "#DEDEDF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 458.9,
    y1: 208,
    x2: 448.9,
    y2: 208
  }))), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_650_",
    fill: "none",
    stroke: "#DEDEDF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 45.9,
    y1: 188,
    x2: 66.9,
    y2: 188
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_500_",
    fill: "none",
    stroke: "#DEDEDF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 109.9,
    y1: 66,
    x2: 120.9,
    y2: 66
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_937_",
    fill: "none",
    stroke: "#DEDEDF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 100.9,
    y1: 55,
    x2: 128.9,
    y2: 55
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_651_",
    fill: "none",
    stroke: "#DEDEDF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 39.9,
    y1: 212,
    x2: 61.9,
    y2: 212
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_656_",
    fill: "none",
    stroke: "#DEDEDF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 53.9,
    y1: 200,
    x2: 71.9,
    y2: 200
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoallexperiments);
export default __webpack_public_path__ + "static/media/noallexperiments.34d7756ec68880fec7de3e25b4f65753.svg";
export { ForwardRef as ReactComponent };